<template>
    <div class="landing-page">
        <div class="themeBg"><img :src="themeBg" alt=""></div>
        <div class="content">
            <div class="bottom">
                <div @click="downlodClick"><img class="btn" src="../assets/images/btn_download2.png" alt=""></div>
                <template v-if="isWeChatBrowser">
                    <div class="mt-20 launch-box" style="position:relative;">
                        <div v-if="showBakBtn" @click="showWall" class="bak-btn"><img class="btn" src="../assets/images/btn_openApp3.png" alt=""></div>
                        <wx-open-launch-app
                            class="launch-btn"
                            id="launch-btn"
                            :appid="appid" 
                            @ready="handleReady"
                            @launch="handleLaunch"
                            @error="handleError"
                            :extinfo="extinfo">
                            <script type="text/wxtag-template">
                            <style>
                                .btn-box { width: 100%; background: #fff; }
                                .btn { width: 100%; }
                            </style>
                            <div class="btn-box"><img class="btn" src="https://cms-oss.sgmlink.com/5b050c44be71e/61d682cc50ddded5a7afdb13/btn_openApp3.png" alt=""></div>
                            </script>
                        </wx-open-launch-app>
                    </div>
                </template>
                <template v-else>
                    <div class="mt-20" @click="openAppClick"><img class="btn" src="../assets/images/btn_openApp3.png" alt=""></div>
                </template>
                <p class="txt mt-50">Android 开发者：上汽通用汽车销售有限公司 <template v-if="version">版本：{{ version }}</template></p>
                <p class="txt">iOS 开发者：上汽通用汽车销售有限公司 <template v-if="version">版本：{{ version }}</template></p>
                <div>
                    <a class="txt txt-d-line" href="https://raa.oc.saic-gm.com/cmsraa/ue/index.html?sid=5b050c44be71e&cmid=5b421b7731512&id=60f77ca0ad7a6ca5d4612cfd&cf=content">权限详情</a>
                    <span class="txt mlr-5">&</span>
                    <a class="txt txt-d-line" href="https://raa.oc.saic-gm.com/cmsraa/ue/index.html?sid=5b050c44be71e&cmid=5cb3d4d670640&id=62d6078b30b48e1b4d302482&cf=html">上汽通用汽车个人信息保护政策</a>
                </div>
            </div>
            <div v-if="wallStatus" class="wall-page"></div>
        </div>
    </div>
</template>
<script>
    import { getAppInfo } from "@/axios/index.js"
    import { Toast } from 'vant';
    let Base64 = require('js-base64').Base64
    export default {
        name: 'Landing',
        data () {
            return {
                showBakBtn: true,
                appid: "",
                channel: this.$route.query.channel || "",
                isIOS: false,
                inforDetail: this.$route.query.inforDetail || "",
                wallStatus: false,
                isWeChatBrowser: false, // 仅在微信浏览器，非小程序
                themeBg: "",
                extinfo: Base64.encode('{}'),
                version: ""
            }
        },
        created(){
            this.getAppInfo();
            this.appid = process.env.VUE_APP_appId;
            this.isWeChatBrowser = (window.isWeChat && !window.isWxmp);
            if(this.$route.params.theme){
                this.themeBg = `${process.env.VUE_APP_CMS}${this.$route.params.theme}.png`;
            }else{
                // this.themeBg = `${process.env.VUE_APP_CMS}default_v2.png`
                this.themeBg = 'https://cms-oss.sgmlink.com/5b050c44be71e/62d75ace4e39ded540caef01/default_v2.png';
            }
        },
        mounted(){
            //判断设备对象是iphone还是安卓
            var ua = navigator.userAgent.toLowerCase();//获取判断用的对象

            // if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //     this.wallStatus = true;
            // } else {
            //     this.wallStatus = false;
            // }

            if (/iphone|ipad|ipod/.test(ua)) {
                this.isIOS = true
            } else {
                this.isIOS = false
            }
            
            this.$dcpTrack('pv',"APP下载落地页",{channelId: this.channel});
            
        },
        methods: {
            async getAppInfo(){
                let res = await getAppInfo();
                if(res?.data?.version){
                    this.version = res.data.version;
                }
            },
            openAppClick(){
                this.$dcpTrack('act','APP下载落地页_前往APP',{channelId: this.channel});
                if(this.inforDetail){
                    window.location.href = 'mychevy://mychevy?inforDetail=' + this.inforDetail;
                }else{
                    window.location.href = 'mychevy://mychevy';
                } 
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == "undefined" || hidden == false) {
                        //应用宝下载地址
                        Toast('请先安装MyChevy APP');
                    }
                }, 2000);
            },
            downlodClick(){
                this.$dcpTrack('act','APP下载落地页_立即下载',{channelId: this.channel});
                if (this.isIOS) {
                    window.location.href = "https://itunes.apple.com/cn/app/mychevy/id587800848";
                } else {
                    if(this.isWeChatBrowser){
                        this.wallStatus = true;
                        return
                    }
                    this.downLoadAPK();
                }
                // if(this.$route.params.theme){
                //     let SAcode = this.$route.params.theme + "_landing_download";
                //     this.$dcpTrack('act',SAcode,{channel_id: this.channel});
                // }else{
                //     this.$dcpTrack('act','landing_download',{channel_id: this.channel});
                // }  
            },
            downLoadAPK () {
                getAppInfo().then(res => {
                    if (res.errcode == 0) {
                        window.location.href = res.data.download_url
                    }
                })
            },
            handleReady(res){
                setTimeout(()=> {
                    this.showBakBtn = false;
                }, 300)
                console.log("<wx-open-launch-app>, ready", res)
            },
            handleLaunch(e){
                this.$dcpTrack('act','APP下载落地页_前往APP',{channelId: this.channel});
                console.log('success', e);
            },
            handleError(e){
                console.log('fail', e.detail);
                this.wallStatus = true;
            },
            showWall(){
                // this.wallStatus = true;
            }
        }
    }
</script>
<style lang="less" scoped>
    .landing-page {
        box-sizing: border-box;
        min-height: 100%;
        // background: url(../assets/images/new_bg_v2.png) no-repeat top center;
        // background-size: 100%;
        position: relative;
        .themeBg {
            line-height: 0;
            img {
                width: 100%;
            }
        }
        .content {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            padding: 450px 20px 44px;
        }
        .bottom {
            display: flex;
            flex-direction: column;
            text-align: center;  
            .launch-box {
                position: relative;
                height: 52px;
            }  
            .bak-btn {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 10;
                width: 100%;
                height: 100%;
                background: #fff;
            }
            .launch-btn {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
        }
        .txt{
            font-size: 10px;
            color: #7c7d81;
            line-height: 20px; 
            
        }
        .btn {
            width: 100%;
        }
        .mt-20 {margin-top: 20px;}
        .mt-50 {margin-top: 50px;}
        .mlr-5{margin: 0 5px}
        .txt-d-line{text-decoration: underline;font-weight: 500;}
    }
    .wall-page {
        position: fixed;
        left: 0;
        right: 0;
        z-index: 1;
        top: 0;
        bottom: 0;
        z-index: 10;
        background: url(../assets/images/browser.png) no-repeat right top rgba(0, 0, 0, 0.8);
        background-size: 375px 180px;
    }
</style>
